import { Timestamp, TimestampType } from '@britishcouncil/common-core';
import { LrwSessionsQueryFilters } from './types';

const DEFAULT_DATE_RANGE_DAYS = 90;

export const getDefaultLrwSessionDateRange = (): [TimestampType, TimestampType] => {
  const today = Timestamp.startOfDay(Timestamp.now());
  return [today, Timestamp.addDays(DEFAULT_DATE_RANGE_DAYS)(today)];
};

export const getDefaultLrwSessionsQueryFilters = (): LrwSessionsQueryFilters => {
  const [fromDate, toDate] = getDefaultLrwSessionDateRange();
  return {
    fromDate: Timestamp.toISODate(fromDate),
    toDate: Timestamp.toISODate(toDate),
  };
};
